import styled from '@emotion/styled';
import color from 'src/theme/color';

export const DialogTitle = styled.h2`
    text-align: center;
    font-weight: bold;
    color: ${color.white};
    font-size: 20px;
    margin: 0 0 20px 0;
`;

export const DialogContent = styled.div`
    padding: 0 24px 20px 24px;
`;

export const CloseButtonContainer = styled.div`
    position: absolute;
    right: 8px;
    top: 8px;
`;

export const PriorityList = styled.div`
    display: flex;
    flex-direction: column;
    gap: 12px;
`;

export const PriorityItem = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
`;

export const PriorityLabel = styled.span`
    color: ${color.white90};
    font-size: 14px;
    font-weight: 500;
    min-width: 70px;
`;

export const PriorityRange = styled.span`
    color: ${color.lightningYellow};
    font-size: 14px;
    font-weight: 600;
`;

export const PriorityInfoDialogPaperProps = {
    sx: {
        backgroundColor: color.darkBlue,
        color: color.white,
        padding: '20px',
        borderRadius: '8px',
        margin: '16px',
        maxWidth: '400px',
        minWidth: '300px',
        position: 'relative'
    }
};
